"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _zod = require("zod");

var _widgetContainer = require("@insided/deprecated-preact-components/widget-container");

var _index = _interopRequireDefault(require("../widget-featured-topics/index.sync"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'dynamic_content';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-dynamic_content';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  selectedMobileLayout: _zod.z.union([_zod.z.literal('verticallyStacked'), _zod.z.literal('horizontallyScrollable')], undefined).optional(),
  buttonURL: _zod.z.string(),
  buttonLabel: _zod.z.string(),
  maxNumberOfItems: _zod.z.number(),
  firstTopicsNumber: _zod.z.number(),
  categories: _zod.z.array(_zod.z.string()),
  publicTags: _zod.z.array(_zod.z.string()),
  moderatorTags: _zod.z.array(_zod.z.string()),
  selectedContentType: _zod.z.enum(['all', 'article', 'conversation', 'question', 'idea', 'productUpdate']),
  selectedContentTypes: _zod.z.array(_zod.z.enum(['article', 'conversation', 'question', 'idea', 'productUpdate'])),
  selectedSortType: _zod.z.enum(['lastActivityAt', 'replyCount', 'views']),
  selectedDisplayViewPreference: _zod.z.string(),
  createdInLastDays: _zod.z.number(),
  enablePublicationDateFilter: _zod.z.boolean()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var DynamicContentWidget = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DynamicContentWidget, _Component);

  var _super = _createSuper(DynamicContentWidget);

  function DynamicContentWidget() {
    (0, _classCallCheck2.default)(this, DynamicContentWidget);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(DynamicContentWidget, [{
    key: "render",
    value: function render() {
      var _config$firstTopicsNu;

      var _this$props = this.props,
          config = _this$props.config,
          isNested = _this$props.isNested,
          isSidebar = _this$props.isSidebar;
      return (0, _preact.h)(_index.default, {
        config: _objectSpread(_objectSpread({}, config), {}, {
          topics: [],
          firstTopicsNumber: (_config$firstTopicsNu = config.firstTopicsNumber) !== null && _config$firstTopicsNu !== void 0 ? _config$firstTopicsNu : 0
        }),
        widgetName: "dynamic-content",
        isNested: isNested,
        isSidebar: isSidebar,
        featuredTopics: this.props.dynamicContentData
      });
    }
  }]);
  return DynamicContentWidget;
}(_preact.Component);

exports.default = DynamicContentWidget;